var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lifestyle analysis"},[_c('div',{staticClass:"statistics card"},[_c('h5',[_vm._v("Graph")]),_c('FoodGraph',{attrs:{"data":_vm.sortedMacronutrientArr,"food":"nutrition"}})],1),_c('div',{staticClass:"record card"},[_c('h5',[_vm._v("Records")]),_c('FoodTable',{attrs:{"food":_vm.food}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }